module.exports = __webpack_public_path__ + "static/media/learn-skills@3x.9d504941.png";